// Miky Motorsport - sektory + historie PB (B3). Ciste funkce (bez THREE/Rapier), testovatelne.
// Sektory = trat rozdelena na n casti dle checkpointu; split = cas prejezdu hranice sektoru.
// Slouzi k "kde ztracim cas" (delta vs nejlepsi) + graf zlepsovani PB.

// Hranicni indexy checkpointu pro n sektoru (default 3). Vraci n-1 indexu (b1..b_{n-1}),
// kde PREJEZD cp b_i zaznamena split. Pri malo checkpointech vraci [] (sektory vyp).
export function sectorBoundaries(numCp, n = 3) {
  if (!(Number.isFinite(numCp)) || numCp < n + 1) return [];
  const b = [];
  for (let i = 1; i < n; i++) {
    const idx = Math.round((numCp * i) / n);
    if (idx <= 0 || idx >= numCp) return []; // degenerovane
    if (b.length && idx <= b[b.length - 1]) return []; // nerostouci
    b.push(idx);
  }
  return b;
}

// Casy sektoru z casu prejezdu hranic (splits, relativni k zacatku kola) a celkoveho lapTime.
// splits ma n-1 prvku -> vraci n sektoru. lapTime je celkovy cas kola.
export function sectorTimes(splits, lapTime) {
  const secs = [];
  let prev = 0;
  for (const s of splits) { secs.push(s - prev); prev = s; }
  secs.push(lapTime - prev);
  return secs;
}

// Rozdily aktualnich sektoru vs nejlepsich (cur[i]-best[i], zaporne = zlepseni).
// null kdyz nelze porovnat (chybi/nesedi delka).
export function sectorDeltas(cur, best) {
  if (!Array.isArray(cur) || !Array.isArray(best) || cur.length === 0 || cur.length !== best.length) return null;
  return cur.map((v, i) => v - best[i]);
}

// Pridej hodnotu do historie (max `cap`, dropuj nejstarsi). Vraci NOVE pole (nemutuje).
export function pushHistory(arr, value, cap = 20) {
  const a = Array.isArray(arr) ? arr.slice() : [];
  if (!(value > 0)) return a;
  a.push(value);
  return a.length > cap ? a.slice(a.length - cap) : a;
}
